import { iStoreCaseConfiguration } from '@/Interfaces/storeCaseConfiguration';
import { defineStore } from 'pinia';
import { iCaseComponentsResultItem, tCaseModel, tItemsFromApi } from '@/Interfaces/caseComponentsLib';
import { presetsLib } from '@/Constants/presetsLib';
import { colors } from '@/Constants/colors';
import { casesLib } from '@/Constants/casesLib';
import { computeConfigurationCost } from '@/libs/calcConfigurationCost';

export const useStoreCaseConfiguration = defineStore('storeCaseConfiguration', {
    state: () : iStoreCaseConfiguration => ({
        selectedCaseModel: undefined,
        selectedCasePresetId: undefined,
        blenderName: undefined,
        caseItems: [],
        drawerSeparators: [],
        expandedDrawersPrototypeId: [],
        isCloseDoors: false,
        isDecoration: false,
        colorFrame: colors[0].hex,
        colorFace: colors[1].hex,
    }),
    getters: {
        getIsDefaultColorSettings: (state) => {
            const isColorFrameDefault= state.colorFrame === colors[0].hex;
            const isColorFaceDefault= state.colorFace === colors[1].hex;
            return isColorFrameDefault && isColorFaceDefault;
        },
        getCountOfDrawerSeparatorById: (state) => {
            return (drawerSeparatorId: string) => {
                const addedSeparator = state.drawerSeparators
                    .find(item => item.prototypeId === drawerSeparatorId);
                if (!addedSeparator) {
                    return 0;
                }
                return addedSeparator.count;
            };
        },
        getIsDrawerExpandedByPrototypeId: (state) => {
            return (prototypeId: string) => {
                return state.expandedDrawersPrototypeId.includes(prototypeId);
            };
        },
        getActivePreset: (state) => {
            return presetsLib
                .find(item => item.selectedCasePresetId === state.selectedCasePresetId);
        },
        getSelectedCaseData: (state) => {
            return casesLib.find(item => item.key === state.selectedCaseModel);
        },
        // getApiImageByXmlId: (state) => {
        //     return (xmlId: string) => {
        //         return state.itemsFromApi
        //             .find(item => item.xmlId === xmlId);
        //     };
        // },
    },
    actions: {
        setSelectedCaseModel(model: tCaseModel) {
            this.selectedCaseModel = model;
        },
        setCaseItemsBundle(data: Array<iCaseComponentsResultItem>) {
            this.caseItems = data;
        },
        setIsCloseDoors(status: boolean) {
            this.isCloseDoors = status;
        },
        switchCloseDoors() {
            this.isCloseDoors = !this.isCloseDoors;
        },
        setIsDecoration(status: boolean) {
            this.isDecoration = status;
        },
        switchDecoration() {
            this.isDecoration = !this.isDecoration;
        },
        setColorFrame(value: string) {
            this.colorFrame = value;
            computeConfigurationCost();
        },
        setColorFace(value: string) {
            this.colorFace = value;
            computeConfigurationCost();
        },
        // setSelectedCasePresetId(id?: string | undefined) {
        //     // TODO выполнять эту функцию при любом изменении шкафа
        //     if (id) {
        //         this.selectedCasePresetId = id;
        //     } else {
        //         this.selectedCasePresetId = undefined;
        //     }
        //     const preset = this.getActivePreset;
        //     if (!preset) return;
        //     this.$patch(JSON.parse(JSON.stringify(preset)));
        // },
        setDrawerSeparatorCountById(id: string, count: number, drawerPrototypeId: string) {
            if (count < 0) {
                count = 0;
            }
            const existingData = this.drawerSeparators
                .find(item => item.prototypeId === id);

            if (!existingData) {
                this.drawerSeparators.push({
                    prototypeId: id,
                    drawerPrototypeId: drawerPrototypeId,
                    count: count,
                });
            } else {
                existingData.count = count;
            }
        },
        setDrawerExpandedByPrototypeId(prototypeId: string, status: boolean) {
            if (status) {
                const isExist = this.expandedDrawersPrototypeId.includes(prototypeId);
                if (!isExist) {
                    this.expandedDrawersPrototypeId.push(prototypeId);
                }
            } else {
                // Скрываем менюшку данному типу ящика
                this.expandedDrawersPrototypeId = this.expandedDrawersPrototypeId
                    .filter(item => item !== prototypeId);
                // Удаляем разделители, соответствующие этому типу ящика
                this.drawerSeparators = JSON.parse(JSON.stringify(this.drawerSeparators
                    .filter(item => item.drawerPrototypeId !== prototypeId)));
            }
        },
        resetStoreConfiguration() {
            this.selectedCaseModel = undefined;
            this.selectedCasePresetId = undefined;
            this.blenderName = undefined;
            this.caseItems = [];
            this.drawerSeparators = [];
            this.expandedDrawersPrototypeId = [];
            this.isCloseDoors = false;
            this.isDecoration = false;
            this.colorFrame = colors[0].hex;
            this.colorFace = colors[1].hex;
        },
    },
});
